import { Signal, Wifi, ArrowUpRight } from "lucide-react";

export const SignalStandalone = () => (
  <section id="standalone" data-testid="signal-standalone" className="signal-standalone signal-chapter">
    <div className="signal-container signal-standalone-grid">
      <div className="signal-standalone-copy">
        <h2 className="signal-eyebrow" data-testid="signal-standalone-label">Standalone, by design</h2>
        <p className="signal-display" data-testid="signal-standalone-headline">Your phone<br />can stay home.</p>
        <p className="signal-body" data-testid="signal-standalone-detail">Pulse One carries its own connection. Core voice interactions work independently of your phone, through built-in cellular and Wi-Fi.</p>
        <div className="signal-connectivity-facts" data-testid="signal-connection-facts">
          <p data-testid="signal-connection-esim"><Signal size={21} aria-hidden="true" /><strong>Built-in eSIM</strong><span>Cellular connectivity</span></p>
          <p data-testid="signal-connection-wifi"><Wifi size={21} aria-hidden="true" /><strong>Wi-Fi</strong><span>Another way to connect</span></p>
        </div>
        <p className="signal-small" data-testid="signal-connection-requirement">An internet connection is required for AI responses.</p>
        <a href="#connected" className="signal-text-link" data-testid="signal-standalone-use-cases">See what you can ask <ArrowUpRight size={17} aria-hidden="true" /></a>
      </div>
      <figure className="signal-city-photo" data-testid="signal-standalone-moment">
        <img src={`${process.env.PUBLIC_URL}/signal-city.webp`} alt="A busy city street with people walking between shops and buildings" loading="lazy" width="1200" height="800" />
        <figcaption><span>Out in the city.</span><span>Connected, on your terms.</span></figcaption>
      </figure>
    </div>
  </section>
);